var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-row" },
    [
      _c("el-switch", {
        attrs: {
          "active-color": _vm.activeSwitchColor,
          "inactive-color": _vm.inactiveSwitchColor
        },
        model: {
          value: _vm.currentValue,
          callback: function($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pl-2 cpointer typographies-paragraph-medium-regular",
          on: {
            click: function($event) {
              _vm.currentValue = !_vm.currentValue
            }
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.textLabel) + "\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }